/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
/*
 * @author Sergey Kuzhavskiy <Praffesor>
 */
angular.module('public.security-manager.hr.employees', [
  'public.security-manager.employee'
]).config(['$stateProvider', $stateProvider =>

  $stateProvider

    .state('public.security-manager.hr.employees', {
      url: '/employees?{ status }',
      template: require('./template.pug'),
      controller: 'SecurityManagerEmployeesController',
      controllerAs: 'employeesCtrl',
      reloadOnSearch: false
    })

]);
